import { combineReducers } from 'redux';

import { IAction, IUser } from '../../../types';
import { SET_PERFEED_RATING_SETTINGS } from '../../../actions/PerfeedActions';

type SettingsType = {
    user: IUser | null;
    subject: string;
    isAnonymous: boolean;
};

const settings = (
    state: SettingsType = { user: null, subject: '', isAnonymous: false },
    action: IAction,
) => {
    switch (action.type) {
        case SET_PERFEED_RATING_SETTINGS:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({ settings });
